"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "demoPageParamsFromDataModel", {
  enumerable: true,
  get: function () {
    return _demoPageParams2.demoPageParamsFromDataModel;
  }
});
Object.defineProperty(exports, "demoPageParamsSchema", {
  enumerable: true,
  get: function () {
    return _demoPageParams.demoPageParamsSchema;
  }
});
var _demoPageParams = require("./demoPageParams.schema");
var _demoPageParams2 = require("./demoPageParams.preprocess");